<template>
    <div>
        <div class="modal-header py-0 d-flex flex-column crm-modal-header">
            <div class="row w-100">
                <div class="col-12 pt-3 pb-1 pr-0 d-flex justify-content-center align-items-center dNone">
                    <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{this.listenStateStatus?$ml.get("EDIT_ACTIVITY"):$ml.get("ADD_ACTIVITY")}}</h5>
                    <button type="button" @click="closeButton"  class="close"  aria-label="Close">
                        <span aria-hidden="true" class="font-40">&times;</span>
                    </button>
                </div>
            
                <ul class=" nav hpx-50 px-2 mincrm-dynamic-tabs" id="newActivityTabMenu" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="activity-tab" data-toggle="tab" :href="'#activityA_'+parentComp" role="tab" aria-controls="deal" aria-selected="true">{{$ml.get("DETAIL_ACTIVITY")}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="reminder-tab" data-toggle="tab" :href="'#reminderA_'+parentComp" role="tab" aria-controls="reminder" aria-selected="false">{{$ml.get('REMINDER')}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="customField-tab" data-toggle="tab" :href="'#customFieldA_'+parentComp" role="tab" aria-controls="customField" aria-selected="false">{{$ml.get('SPECIAL_AREA')}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" @click="watchUpdated=watchUpdated+1" id="file-tab" data-toggle="tab" :href="'#fileA_'+parentComp" role="tab" aria-controls="file" aria-selected="false">{{$ml.get('FILE')}}</a>
                    </li>
                </ul>
                <button type="button" class="close d-none" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="font-40">&times;</span>
                </button>
            </div>
        </div>
        <!--width: 100%; height: 100%; position: fixed; overflow-y: auto;  -->
        <div class="modal-body py-2 pb-0 crm-modal-body">
            <div class="tab-content" id="newActivityTabContent">
                <div class="tab-pane fade show active py-2" :id="'activityA_'+parentComp" role="tabpanel" aria-labelledby="activity-tab">
                    <div class="row">
                        <div class="col-12 p-0 tabletSlide">
                            <!-- <div class="col-12 activitiesType mb-20" v-if="!listenStateStatus">
                                <button class="btn btn-click py-1" @click="activityTypes('call')" :class="{active:activities['type']===1}">
                                    <i class="fa fa-phone-volume mr-1" style="color:#52BA9F"></i> 
                                    {{$ml.get('CALL')}}</button>
                                <button class="btn btn-click py-1" @click="activityTypes('task')" :class="{active:activities['type']===3}">
                                    <i class="fa fa-tasks mr-1" style="color:#49A7F8"></i>
                                    {{$ml.get('TASK')}}</button>
                                <button class="btn btn-click py-1" @click="activityTypes('meeting')" :class="{active:activities['type']===2}">
                                     <i class="fas fa-calendar-check mr-1" style="color:#9666F6"></i>
                                    {{$ml.get('APPOINTMENT')}}</button>
                                <button class="btn btn-click py-1" @click="activityTypes('email')" :class="{active:activities['type']===4}">
                                    <i class="fa fa-envelope mr-1" style="color:#F6BD56"></i>
                                    {{$ml.get('E_MAIL')}}</button>
                            </div> -->
                              <!-- <div class="col-12 btn-group activitiesType mb-20" v-if="!listenStateStatus">
                                <button class="btn btn-click py-2 px-3 h40" @click="activityTypes('call')" :class="{active:activities['type']===1}">
                                    <span> <i class="fa fa-phone-volume mr-1" style="color:#52BA9F"></i> </span>
                                    {{$ml.get('CALL')}}</button>
                                <button class="btn btn-click py-2 px-3 h40" @click="activityTypes('task')" :class="{active:activities['type']===3}">
                                    <span> <i class="fa fa-tasks mr-1" style="color:#49A7F8"></i></span>
                                    {{$ml.get('TASK')}}</button>
                                <button class="btn btn-click py-2 px-3 h40" @click="activityTypes('meeting')" :class="{active:activities['type']===2}">
                                    <span>   <i class="fas fa-calendar-check mr-1" style="color:#9666F6"></i></span>
                                  
                                    {{$ml.get('APPOINTMENT')}}</button>
                                <button class="btn btn-click py-2 px-3 h40" @click="activityTypes('email')" :class="{active:activities['type']===4}">
                                    <span>
                                    <i class="fa fa-envelope mr-1" style="color:#F6BD56"></i>
                                    </span>
                                    {{$ml.get('E_MAIL')}}</button>
                            </div> -->
                             <div class="col-12 btn-group crmButonGroupsType" v-if="!listenStateStatus">
                                <button class="btn btn-click h40" @click="activityTypes('call')" :class="{active:activities['type']===1}">
                                    <span> <i class="fa fa-phone-volume mr-1" style="color:#52BA9F"></i> </span>
                                    {{$ml.get('CALL')}}</button>
                                <button class="btn btn-click h40" @click="activityTypes('task')" :class="{active:activities['type']===3}">
                                    <span> <i class="fa fa-tasks mr-1" style="color:#49A7F8"></i></span>
                                    {{$ml.get('TASK')}}</button>
                                <button class="btn btn-click h40" @click="activityTypes('meeting')" :class="{active:activities['type']===2}">
                                    <span>   <i class="fas fa-calendar-check mr-1" style="color:#9666F6"></i></span>
                                  
                                    {{$ml.get('APPOINTMENT')}}</button>
                                <button class="btn btn-click h40" @click="activityTypes('email')" :class="{active:activities['type']===4}">
                                    <span>
                                    <i class="fa fa-envelope mr-1" style="color:#F6BD56"></i>
                                    </span>
                                    {{$ml.get('E_MAIL')}}</button>
                            </div>
                            
                            <div class="col-12 crmButonGroupsType d-flex" v-else>
                                    <label class="new-label mt-1 mr-2">{{$ml.get('TYPE_ACTIVITY')}}:</label>
                                    <button class="btn btn-click py-1 active">{{activityType(activities['type'], $ml)}}</button>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('SUBJECT')}}</label>
                                    <input type="text" v-model="activities['subject']" @input="changeDate" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <label class="new-label">{{$ml.get('PLANNING_HISTORY')}}</label>
                                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="planning-history-date" :label="$ml.get('SELECT_DATE')" class="new-ctk" v-model="activityDate" @input="changeDate" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                                </div>
                                <div class="col-3 pl-0">
                                    <label class="new-label">{{$ml.get('WHEN')}}</label>
                                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityTime" :label="$ml.get('WHEN')" v-model="activityTime" class="new-ctk" @input="changeDate" format="HH:mm" formatted="HH:mm"  :noLabel="true" :range="false" :onlyTime="true"></vue-ctk-date-time-picker>
                                </div>
                                <div class="col-3 pl-0">
                                    <label class="new-label">{{$ml.get('TIME')}}</label>
                                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityPeriod" :label="$ml.get('TIME')" v-model="activityPeriod" class="new-ctk" @input="changeDate" format="HH:mm" formatted="HH:mm" :noLabel="true" :range="false" :onlyTime="true"></vue-ctk-date-time-picker>
                                </div>
                            </div>
                            
                            <div class="row" v-if="listenStateStatus">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('ASSIGNMENT')}}</label>
                                    <button type="button" class="h-36 bg-white select-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{assignedValueTitle}}
                                    <i class="fa fa-angle-down pull-right ml-2"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left multiChoose p-0">
                                        <ul class="new-dropdown p-0 border-0">
                                            <template v-for="u in validUsers" :key="u._id.$oid"><li v-if="u.x||u._id.$oid==assignedValue" @click="assignedValue=u._id.$oid,assignedValueTitle=u.name+' '+u.surName" :disabled="!u.x" :class="{'active-user':!u.x}">{{u.name}} {{u.surName}}</li></template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row" v-if="listenStateStatus">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('ASSIGNED')}}</label>
                                    <button type="button" class="h40 bg-white select-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{assignedToValueTitle}}
                                    <i class="fa fa-angle-down pull-right ml-2"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left multiChoose p-0">
                                        <ul class="new-dropdown p-0 border-0">
                                            <template v-for="u in validUsers" :key="u._id.$oid"><li v-if="u.x||u._id.$oid==assignedValue" @click="assignedToValue=u._id.$oid,assignedToValueTitle=u.name+' '+u.surName" :disabled="!u.x" :class="{'active-user':!u.x}">{{u.name}} {{u.surName}}</li></template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row" v-else>
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('ASSIGNED')}}</label>
                                    <button type="button" class="h40 bg-white select-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{assignedToValueTitle}}
                                    <i class="fa fa-angle-down pull-right ml-2"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left multiChoose p-0">
                                        <ul class="new-dropdown p-0 border-0">
                                            <template v-for="u in validUsers" :key="u._id.$oid"><li v-if="u.x" @click="assignedToValue=u._id.$oid,assignedToValueTitle=u.name+' '+u.surName">{{u.name}} {{u.surName}}</li></template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('COMPANY')}}</label>
                                    <div class="position-relative">
                                        <input type="text" v-model="organizationKeyword" :placeholder="$ml.get('COMPANY')" @click="routerRequest('organization')" class="new-input">
                                        <ul class="new-dropdown autocomplete-results" v-show='isHiddenOrganization'>
                                            <li class="autocomplete-result" v-for='(result, i) in items' @click="setResult(result,'organization')">{{result.name}}</li>
                                        </ul>
                                        <ul class="new-dropdown autocomplete-results" v-show="items.length<1 && isHiddenOrganization">  
                                            <li class="autocomplete-result"> {{$ml.get('NOT_FOUND_COMPANY')}}</li>
                                            <li class="autocomplete-result f-w-normal font-family-bold f-14" @click="addOrg=true,isHiddenOrganization=false"> {{$ml.get('ADD_COMPANY')}} <i class="fa fa-plus float-right color-primary"></i></li>
                                        </ul>
                                    </div>
                                    <div v-show="addOrg" class="col-12">
                                        <div class="row addContact">
                                            <div class="col-12 d-flex justify-content-between align-items-center fastAdd">
                                                <label class="font-m h-36 py-2 m-0"> {{$ml.get('QUICK_ADD_COMPANY')}}</label>
                                                <span class="fa fa-close font-m cursor-pointer" @click="closeOrgButton" ></span>
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('NAME')}} * </label>
                                                <input type="text" v-model="addOrgArray['name']" :placeholder="addOrgArray['name']"  class="new-input">
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('TYPE_COMPANY')}}*</label>
                                                <div class="bg-white h-36">
                                                    <v-select :options="customerType" :reduce="label => label.value" label="label" v-model="addOrgArray['isCandidate']" :searchable="false"/>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('PHONE')}}*</label>
                                                <input type="number" onwheel="this.blur()" v-model="addOrgArray['phone']"  class="new-input">
                                            </div>
                                            <div class="col-12 organizationBtnStyle my-2">
                                                <button @click="saveOrgButton" class="btn-new save mcBgDark">{{$ml.get('SAVE')}}</button>
                                                <button @click="closeOrgButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('PERSON')}}</label>
                                    <div class="position-relative">
                                        <input type="text" v-model="contactKeyword" :placeholder="$ml.get('PERSON')" @click="routerRequest('contact')" class="new-input">
                                        <ul class="new-dropdown autocomplete-results" v-show='isHiddenContact' @blur="isHiddenContact=false">
                                            <li class="autocomplete-result" v-for='(result, i) in items' @click="setResult(result,'contact')">{{result.n}} {{result.sn}}</li>
                                        </ul>
                                        <ul class="new-dropdown autocomplete-results" v-show="items.length<1 && isHiddenContact">  
                                            <li class="autocomplete-result"> {{$ml.get('NOT_FOUND_PERSON')}}</li>
                                            <li class="autocomplete-result f-w-normal font-family-bold f-14" @click="addContact=true,isHiddenContact=false"> {{$ml.get('ADD_PERSON')}} <i class="fa fa-plus float-right color-primary"></i></li>
                                        </ul>
                                    </div>
                                    <div v-show="addContact" class="col-12">
                                        <div class="row addContact">
                                            <div class="col-12 d-flex justify-content-between align-items-center fastAdd">
                                                <label class="font-m h-36 py-2 m-0"> {{$ml.get('QUICK_ADD_CONTACT')}}</label>
                                                <span class="fa fa-close font-m cursor-pointer" @click="closeContactButton" ></span>
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('NAME')}} {{$ml.get('SURNAME')}}* </label>
                                                <input type="text" v-model="addContactArray['name']" :placeholder="addContactArray['name']"  class="new-input">
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">Gsm*</label>
                                                <input type="number" onwheel="this.blur()" v-model="addContactArray['gsm']"  class="new-input">
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('E_MAIL')}}*</label>
                                                <input type="text" v-model="addContactArray['mail']"  class="new-input">
                                            </div>
                                            <div class="col-12 organizationBtnStyle my-2">
                                                <button @click="saveContactButton" class="btn-new save mcBgDark">{{$ml.get('SAVE')}}</button>
                                                <button @click="closeContactButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="addContact" v-show="isNewOrganization&&organizationId&&contactId!==''">
                                        <div class="col-12 dealBtnStyle mt-2">
                                            <label class="f-w-normal font-family-bold text-danger f-14">{{$ml.get('RELATION_CONTACT_TO_ORGANIZATION')}}</label>
                                            <button @click="relationButton" class="btn-new save">{{$ml.get('RELATION_CONTACT_TO_ORGANIZATION_BTN')}}</button>
                                            <button @click="relationCancelButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('OPPORTUNITY')}}</label>
                                    <div class="position-relative">
                                        <input type="text" v-model="dealKeyword" :placeholder="$ml.get('OPPORTUNITY')"  @click="routerRequest('deal'), isHiddenDeal=!isHiddenDeal" class="new-input">
                                        <ul class="new-dropdown autocomplete-results" v-show='isHiddenDeal' @blur="isHiddenDeal=false">
                                            <li class="autocomplete-result" v-for='(result, i) in items' @click="setResult(result,'deal')">{{result.title}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row mb-20">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('NOTE')}}</label>
                                    <div>
                                        <addNotePanel :activityNote="activitiesNote" ref="addNotePanel" :activityId="activityId" @addNote="addNoteF" :specialStatu="listenStateStatus" :method="methods" @returnNote="returnNote($event)" class="mt-1 w-100"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 p-2" v-if="listenStateStatus&&notes.length>0">
                                    <label class="new-label">{{$ml.get('PREVIOUS_NOTES')}}</label>
                                    <ul class="list-unstyled previewNotes">
                                        <li v-for="(not,index) in validNotes" class=" mb-1">
                                            <label class="m-0 f-14 text-danger">{{formatDate(not.created_at.$date, "Do MMMM YYYY")}}</label>
                                            <template v-for="u in validUsers" :key="u && u._id ? u._id.$oid : u.name">
                                                <label class="m-0 f-14 text-danger" v-if="u && u._id && not && not.cuid && not.cuid.$oid && u._id.$oid == not.cuid.$oid">- {{ u.name}} {{u.surName}}</label>
                                            </template>
                                            <br>
                                            <div class="d-flex justify-content-between align-items-center mt-1">
                                                <label class="m-0 f-14 text-dark" v-if="not!==undefined" v-html="not.text" ></label>
                                                <div class="mr-2">
                                                <i class="icon-line-duzenle ml-1 clickable f-16 "  @click="selected=not.id.$oid" ></i>
                                                <i class="icon-line-iptal clickable iptal f-16"  @click="deleteCommit(index,not.id.$oid)" ></i>
                                                </div>
                                            </div>
                                            <div v-show="selected===not.id.$oid">
                                                <textarea type="text" class="border pl-2 border-radius-20 light-blue-border w-75 f-14 font-family-regular" rows="3" @keyup.enter="noteUpdate(index,updateNote[index],not.id.$oid)" :value="updateNote[index]=convertHtml(not.text)" @input="definedNot(index,$event.target.value)" />
                                                <i class="icon-line-yesiltik clickable" @click="noteUpdate(index,updateNote[index],not.id.$oid)"></i>
                                                <i class="icon-line-iptal clickable" @click="selected=''"></i>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-3">
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex align-items-center">
                                        <label class="switch heightSwitch m-0">
                                        <input type="checkbox" :checked="activities['done']"  @click="activities['done']=!activities['done']">
                                        <span class="slider round true"></span>
                                        </label>
                                        <span class="new-label ml-2"> {{$ml.get('DONE_SELECT')}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade py-2" :id="'reminderA_'+parentComp" role="tabpanel" aria-labelledby="reminder-tab">
                    <div v-if="listenStateStatus">
                        <reminderPanel :reminders="reminders"  @updateRemindersData="updateRemindersData" @successUpsert="getRemindersF()" :activityId="activityId" />
                    </div>
                    <div v-else>
                        <reminderPanel :reminders="reminders"  @updateRemindersData="updateRemindersData" />
                    </div>
                </div>
                <div class="tab-pane fade py-2" :id="'customFieldA_'+parentComp" role="tabpanel" aria-labelledby="customField-tab">
                    <div class="w-100" v-show="customFieldArray.length>0">
                        <special-area type="save" ref="customFields" :domain="domain" :edit="listenStateStatus" @returnCustomData="returnCustomData($event)" :editArray="$store.state.editLine" :user="user" postField="activity" :users="users" @returnCustomField="returnCustomField=$event" :active="customFieldActive" :customFieldType="customFieldType" :customField="customFieldArray" :allcustomFieldArray="customFieldArray"></special-area>
                    </div>
                </div>
                <div class="tab-pane fade py-2" :id="'fileA_'+parentComp" role="tabpanel" aria-labelledby="file-tab">
                    <div class="w-100">
                        <file   :activite="activityId"
                                :watchUpdated="watchUpdated"
                                :customerFiles="customerFiles"
                                @showCustomerFile="showCustomerFile($event)"
                                @addNewFile="addNewFile($event)"
                                @deleteFile="function($event){ 
                                    for(k in this.customerFiles){
                                    if(this.customerFiles[k]['oid']==$event['oid']){
                                        this.customerFiles.splice(k,1)
                                    }
                                }}"
                        ></file>
                    </div>
                </div>
            </div>
         
        </div>
        <div class="row crm-modal-footer stickyBtn" :class="{'mx-0':true}">
            <hr class="col-12 d-none d-md-block mt-0"/>
            <div class="col-12 dealBtnStyle pb-3" v-if="listenStateStatus===false">
                        <button @click="saveButton" class="btn-new save ml-2">{{$ml.get('SAVE')}}</button>
                        <!-- <button @click="closeButton" v-show="this.data===undefined" class="btn-new">{{$ml.get('CANCEL')}}</button>   -->
                        <button @click="closeButton" class="btn-new">{{$ml.get('CANCEL')}}</button>  
            </div>
            <div class="col-12 dealBtnStyle pb-3" v-if="listenStateStatus">
                   <button data-dismiss="modal" @click="saveButton" class="btn-new save ml-2">{{$ml.get('UPDATE')}}</button>
                    <button @click="closeButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
            </div>
        </div>

        <!-- Değişiklik uyarısı Modal -->
        <div class="modal h-100" id="changeAlertModalActivity2" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="changeAlertModalActivityLabel2" aria-hidden="true" style="z-index:99999;">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content px-2 py-3 bg-white" >
                    <div class="modal-body text-center">
                        <i class="fas fa-exclamation-circle danger fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                        <h2 class="my-3" style="color:#47495A;">Uyarı</h2>
                        <p style="color: #53565E; font-size: 16px;">
                            Değişiklikleri kaydetmek istiyor musunuz?
                        </p>
                    </div>
                    <div class="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal" @click="closeButtonModal()">{{$ml.get('NO')}}</button>
                        <button type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" @click="saveButton">{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Vue from 'vue'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
import specialArea from '@/components/customField'
import addNotePanel from '@/components/addNotePanel'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
import reminderPanel from '@/components/reminderPanel'
import _ from 'underscore'
import file from '@/components/file'
export default {
    name: 'newActivities',
    data () {
        return {
            updateActictyId:"",
            activities:{},
            activityId:"",
            returnCustomField:[],
            activityTypeText:"",
            activityDate:"",
            createDate:"",
            activityTime:"",
            activityPeriod:"00:00",
            selectedDone:false,
            organizationKeyword:"",
            sipOrganizationKeyword:false,
            contactKeyword:"",
            sipContactKeyword:false,
            dealKeyword:"",
            selectOrganization:"",
            selectContact:"",
            selectDeal:"",
            isHiddenOrganization:false,
            isHiddenContact:false,
            isHiddenDeal:false,
            items:[],
            organizationId:"",
            contactId:"",
            dealId:"",
            methods:"save",
            assignedToValueTitle:"Seçiniz",
            assignedToValue:"",
            assignedValueTitle:"Seçiniz",
            assignedValue:"",
            specialArray:[],
            customFieldType:1,
            customFieldActive:false,
            notes:[],
            selected:"",
            updateNote:[],
            activitiesNote:[],
            customFieldArray:[],
            domain:6,
            domains:[5,6,7,8],
            fileId:{},
            watchUpdated:0,
            reportsObjId:"",
            languagetr:{
                language: 'Türkçe', 
                months: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'], 
                monthsAbbr: ['Ock','Şbt', 'Mrt', 'Nsn', 'Mays', 'Hazi', 'Tem', 'Ağs', 'Eyl', 'Ekm', 'Ksm', 'Arlk'], 
                days: ['P', 'PT', 'S', 'Ç', 'P', 'C', 'CT'], 
                rtl: false, 
                ymd: 'yyyy-MM-dd', 
                yearSuffix: '',
               
            },
            addOrg:false,
            addOrgArray:{'isCandidate':true},
            addContact:false,
            addContactArray:[],
            isNewOrganization:false,
            customerFiles:[],
            customerType:[
                {value: true, label: this.$ml.get('LEAD')},
                {value: false, label: this.$ml.get('CUSTOMER')},
            ],
            reminders:[
                {
                    day:'',
                    time:'12:00',
                    date:{$date:''},
                    isActive:true,
                    isQueued:false
                }
            ]
        }
    },
    computed: {
        ...mapState([
            'baseUrl',
            'editLine',
            'editLineStatu'
        ]),
        ...mapGetters(['localeLang']),
        listenState() { return this.$store.state.editLine },
        listenStateStatus() { return this.$store.state.editLineStatu },
        validUsers() {
            return (Array.isArray(this.users) ? this.users : []).filter(user =>
                user && user._id && user._id.$oid
            )
        },
        validNotes() {
            return (Array.isArray(this.notes) ? this.notes : []).filter(note =>
                note && note.x && note.created_at && note.created_at.$date &&
                note.cuid && note.cuid.$oid && note.id && note.id.$oid
            )
        },
    },
    components:{
        'special-area':specialArea,
        'addNotePanel':addNotePanel,
        'reminderPanel':reminderPanel,
        'file':file
    },
    props:["data","user","users","contactOrg","clearModal","permission","parentComp","sipData","here","updateActictyId","contact"],
    methods:{
        formatDate(value, format) {
            return this.$moment(value).format(format);
        },
        activityType:function (type,ml){
            const mlInst = ml || this.$ml;
            var activityTypeMap={ 1:mlInst.get('CALL'),2:mlInst.get('APPOINTMENT'),3:mlInst.get('TASK'),4:mlInst.get('E_MAIL')}
            return activityTypeMap[type] || ''
        },
        updateRemindersData(newReminders){
            this.reminders = newReminders
        },
        getReportsId(e){
            this.reportsObjId=e
            console.log(this.reportsObjId);
        },
        addNewFile(event){
            // this.fileId=event
            this.customerFiles.unshift(event) 
        },
        activaTab(){
            // $('#newActivityTabMenu a[href="#' + "'activityA_'+parentComp" + '"]').tab('show');
            // activaTab("'activityA_'+parentComp")
              $('.mincrm-dynamic-tabs a[href="#' + 'activityA_'+this.parentComp + '"]').tab('show');
        },
        showCustomerFile(event){
            this.customerFiles=event
        },
        getRemindersF(){
            var form = {}
            form.activityId = this.activityId
            this.getReminders(form).then((res)=>{return res}).then((res)=>{
                console.log("getReminders res")
                console.log(res)
                if(res.status.code=='0'){
                    var remindersMutation = res.content.reminders.filter(r => {
                        return r.isActive==true&&r.date!==null
                    })
                    remindersMutation.forEach(r => {
                        if(r.day==undefined && r.date.$date!==undefined){
                            r.day = this.$moment(r.date.$date).format('YYYY-MM-DD')
                        }
                        if(r.time==undefined && r.date.$date!==undefined){
                            r.time = this.$moment(r.date.$date).format('HH:mm')
                        }
                    })
                    this.reminders = remindersMutation
                }
            })
        },
        returnCustomData(data){
            data['edit']=true
            this.$store.dispatch('editLine', data)
        },
        addNoteF(noteObj){
            this.notes.push(noteObj)
        },
        returnNote(event){
            this.activities['note']=event
        },
        permissionSet(){
            if(this.permission===true){
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                })
                return true
            }else{
                return false
            }
        },
        getCustomFields(){
            axios({
                method:'POST',
                url:`/getCustomFields`,
                baseURL: this.baseUrl,
                data:{
                    domain:this.domain
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.customFieldArray = res.data.content.customFields
                }                    
            })
            
        },
        clearCustomFields(){
            const customFields = this.$refs.customFields
            if (customFields && typeof customFields.clearCustom === 'function') {
                customFields.clearCustom()
            }
        },
        activityTypes(type){
            setTimeout(() => {
            this.clearCustomFields();
            }, 0);
            let types=[]
            if(type==='call'){
                types["call"]=this.$ml.get('CALL'),
                this.activities["type"]=1
                this.customFieldType=1
                this.domain=6
            }else if(type==='task'){
                types["task"]=this.$ml.get('TASK'),
                this.activities["type"]=3
                this.customFieldType=3
                this.domain=5
            }else if(type==='meeting'){
                types["meeting"]=this.$ml.get('APPOINTMENT'),
                this.activities["type"]=2
                this.customFieldType=2
                this.domain=8
            }else if(type==='email'){
                types["email"]=this.$ml.get('E_MAIL'),
                this.activities["type"]=4
                this.customFieldType=4
                this.domain=7
            }
            this.activityTypeText=types[type]
            this.getCustomFields()
        },
        saveButton(){
            if(this.activities['done']===undefined){
                this.activities['done']=false
            }
            if(this.activities['subject']===undefined){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('SUBJECT_CANNOT_BE_BLANK')
                })
                setTimeout(() => {
                    $(".crm-modal-body").css("display","block")
                    $(".crm-modal-header").css("position","sticky")
                    $(".crm-modal-footer").css("display","flex")
                    $(".crm-modal-content").css("width","100% ")
                }, 300);
                return false
            }
            if(this.assignedToValue==="0"){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('ASSIGMENT_NOT_DONE')
                })
                setTimeout(() => {
                    $(".crm-modal-body").css("display","block")
                    $(".crm-modal-header").css("position","sticky")
                    $(".crm-modal-footer").css("display","flex")
                    $(".crm-modal-content").css("width","100% ")
                }, 300);
                return false
            }else{
                this.activities["assignedTo"]={"$oid":this.assignedToValue}
            }
            if(this.listenStateStatus){
                if(this.assignedValue==="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('WARNING'),
                        text: this.$ml.get('ASSIGNER_NOT_SELECTED')
                    })
                    setTimeout(() => {
                        $(".crm-modal-body").css("display","block")
                        $(".crm-modal-header").css("position","sticky")
                        $(".crm-modal-footer").css("display","flex")
                        $(".crm-modal-content").css("width","100% ")
                    }, 300);
                    return false
                }else{
                    this.activities["assignor"]={"$oid":this.assignedValue}
                }
            }
            
            if(this.organizationId!=""){
                let obj ={}
                obj["$oid"]=this.organizationId
                this.activities["orgId"]=obj
            }
            if(this.contactId!="" && this.contactKeyword!=""){
                let obj ={}
                obj["$oid"]=this.contactId
                this.activities["contactId"]=obj
            }
            else{
                this.activities["contactId"]=""
            }
            if(this.dealId!=""){
                let obj ={}
                obj["$oid"]=this.dealId
                this.activities["dealId"]=obj
            }else{
                this.activities["dealId"]=""
            }
            if(this.activities["note"]===""){
                delete this.activities["note"]
            }
            for (var customId in this.returnCustomField){
                if (typeof this.returnCustomField[customId] !== 'function') {
                    this.activities[customId] = this.returnCustomField[customId]
                }
            }
            
            this.changeDate()
            if(this.listenStateStatus===false){
                let url = "addActivity"
                let dataObj={}
                this.activities["customerFileIds"]=this.customerFiles
                dataObj["activityInputObj"]=this.activities
                this.postActivities(url,dataObj)
                this.customerFiles=[]
            }else{
                let url = "updateActivity"
                let dataObj={}
                this.activities["customerFileIds"]=this.customerFiles
               
                if(this.$route.path==="/reports"){
                    dataObj["objId"]=this.$root.$refs.resultTable.activityObjId
                }else{
                    if(this.updateActictyId !="" && this.updateActictyId != undefined){
                        dataObj["objId"]=this.updateActictyId
                    }else{
                        dataObj["objId"]=this.activityId
                    }
                   
                }
                dataObj["updateObj"]=this.activities
                this.postActivities(url,dataObj)
                this.customerFiles=[]
                 const fileComponent = this.$root && this.$root.$refs && this.$root.$refs.file
                 if (fileComponent && typeof fileComponent.inputFileNameClear === 'function') {
                    fileComponent.inputFileNameClear()
                 }
                 if(this.$route.path==="/reports"){
                    setTimeout(() => {
                        this.$root.$refs.groupBuilder.sendQuery() 
                    }, 1000);
                   
                }
            }
            setTimeout(() => {
                $(".crm-modal-body").css("display","block")
                $(".crm-modal-header").css("position","sticky")
                $(".crm-modal-footer").css("display","flex")
                $(".crm-modal-content").css("width","100% ")
            }, 300);
        },
        saveContactButton(){
            let name="",
            surName,phone,url,mail;
            let nameSplit = []
            let dataObj={}
            nameSplit = this.addContactArray['name'].split(" ")
            if(nameSplit.length-1>0){
                for (let index = 0; index < nameSplit.length-1; index++) {
                    name=name+" "+nameSplit[index]
                }
                surName=nameSplit[nameSplit.length-1]
            }else{
                name=nameSplit[0]
            }
            phone=this.addContactArray['gsm']
            mail=this.addContactArray['mail']
            if(name.length>0 && mail!=null && phone!=null ){
                if(phone.length<9){
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: this.$ml.get('PHONE_NUMBER_SHOULD_BE_AT_LEAST_10_DIGITS')
                    })
                }
                else if(!this.validEmail(mail)){
                    return false
                }else{ 
                    url = "addContact"
                    dataObj["contactInputObj"]={"n":name,"sn":surName,"gsm":phone,"email":mail}
                    this.postContact(url,dataObj)
                }
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warning', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('REQUIRED_FIELDS_CANNOT_BE_BLANK')
                })
            }
        },
        postContact(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('NEW_CONTACT_ADDED'),
                        text: res.data.status.desc 
                    })
                    this.isHiddenContact = false
                    this.addContact=false
                    this.addContactArray['gsm']=""
                    this.contactId=res.data.content.contact._id.$oid
                    this.selectContact=res.data.content.contact.n
                    this.items=[]
                    this.isNewOrganization=true
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        closeContactButton(){
            this.addOrg=false
            this.addContact=false
            this.addContactArray['gsm']=""
            this.addContactArray['mail']=""
        },
        saveOrgButton(){
            let url =""
            let obj ={}
            let dataObj={}
            let phone=[]
            if(this.addOrgArray['name'].length>1){
                obj["name"]=this.addOrgArray['name']
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: 'Firma adı boş olamaz!',
                })
                return false
            }
            if(this.addOrgArray['phone'].length>9){
                phone.push(this.addOrgArray['phone'])
                obj["phoneNumbers"] = phone
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARPHONE_COMPANY_LEAST_10_DIGITSNING'),
                })
                return false
            }
            obj["isCandidate"]=this.addOrgArray['isCandidate']
            obj["status"]=true
            url = "addOrganization"
            dataObj["organizationInputObj"]=obj
            this.postOrganization(url,dataObj)
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(email.length>0&&email!==undefined){
                if(re.test(email)===false){
                    this.$notify({ group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('INVALID_EMAIL'),
                        text: this.$ml.get('PLEASE_INSERT_A_VALID_EMAIL')
                    })
                    return false
                }else{
                    return email
                }
            }else{
                return false
            }
        },
        postOrganization(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('NEW_COMPANY_ADDED'),
                        text: res.data.status.desc 
                    })
                    this.addOrgArray['phone']=""
                    this.addOrg=false
                    this.isNewOrganization=true
                    this.organizationKeyword=res.data.content.organization.name
                    this.isHiddenOrganization= false
                    this.organizationId=res.data.content.organization._id.$oid
                    this.selectOrganization=res.data.content.organization.name
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        closeOrgButton(){
            this.addOrg=false
            this.addContact=false
            this.addOrgArray['phone']=""
            this.isHiddenContact=false
        },
        relationButton(){
            this.addOrganizationContact()
        },
        relationCancelButton(){
            this.isNewOrganization=false
        },
        addOrganizationContact(){
             
            axios({
            method:'POST',
            url:'/addOrganizationContact',
            baseURL: this.baseUrl,
            data: {
                objId:this.organizationId,
                newContactId:this.contactId
            },
            withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('COMPANY_AND_CONTACT_ASSOCIATED'),
                        text: res.data.status.desc 
                    })
                    this.isNewOrganization=false
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        convertHtml(value){
            if(this.isHTML(value)){
                return $(value).html()
            }else{
                return value
            }
        },
        definedNot(index,value){
            this.updateNote[index]=value
        },
        isHTML(str) {
            var doc = new DOMParser().parseFromString(str, "text/html");
            return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
        },
        deleteCommit(index,notId){
             
            axios({
                method:'POST',
                url:'/upsertActivityNote',
                baseURL: this.baseUrl,
                data: {
                    activityId:this.activityId,
                    noteText:'',
                    activityNoteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESS_NOTE_HAS_BEEN_DELETED'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    this.notes.splice(index,1);
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        noteUpdate(index,not,notId){
             
            not = '<p>'+not+'</p>'
            axios({
                method:'POST',
                url:'/upsertActivityNote',
                baseURL: this.baseUrl,
                data: {
                    activityId:this.activityId,
                    noteText:not,
                    activityNoteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    this.notes[index]=res.data.content.note
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        postActivities(url,obj){
            if(this.$route.path==="/dealCard/"+this.$route.params.dealId){
                if(this.permissionSet()){
                    return false
                }
            }
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                console.log("res postActivities")
                console.log(res)
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==="0"){
                      this.$emit("updatedCalendar","updateCalendar") 
                    if(this.listenStateStatus===false){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('NEW_ACTIVITY_ADDED'),
                            text: res.data.status.desc 
                        })
                        this.$emit('activityDoneF')
                        this.upsertRemindersF(res.data.content.activity._id.$oid)
                        this.activitiesNote=""
                        this.$emit('refleshData')
                        
                        $('#add').modal('hide')
                        $('#addActivity').modal('hide')
                        if(this.data===undefined){
                            this.clear()
                        }else{
                            this.clearMethod2()
                        }
                    
                    this.$emit('getData',res.data.content.activities)
                    }else{
                        this.$emit('activityDoneF')
                        $('#add').modal('hide')
                        $('#addActivity').modal('hide')
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('ACTIVITY_UPDATE'),
                            text: res.data.status.desc 
                        })
                        this.$emit('refleshData') 
                         
                    }
                   
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        formatUpsertList(originalList,activityId){
            
            const keys = ['date','isActive','isQueued']
            const result = array => array.map( o => keys.reduce((acc,curr)=>{
                acc[curr] = o[curr]
                acc.activityId = {}
                acc.activityId.$oid = activityId
                return acc
            },{}))
            return result(originalList)
        },
        upsertRemindersF(activityId){
            var remindersMutation = this.reminders.filter(r => { return r.date.$date!==''})
            if(remindersMutation.length>0){
                var form = {}
                form.objs = this.formatUpsertList(remindersMutation,activityId)
                this.upsertReminder(form).then((res)=>{return res}).then((res)=>{
                    console.log("upsertReminder res")
                    console.log(res)
                    if(res.status.code!=='0'){
                        this.$notify({ 
                            group: 'foo',
                            type: 'warning', 
                            title: this.$ml.get('WARNING'),
                            text: res.status.desc 
                        })
                    }
                })
            }
        },
         closeButton(){
             const fileComponent = this.$root && this.$root.$refs && this.$root.$refs.file
             if (fileComponent && typeof fileComponent.inputFileNameClear === 'function') {
                fileComponent.inputFileNameClear()
             }
            // if(this.$route.path==="/activities" || this.$route.path==="/deals" || this.$route.path==="/opportunities"){
            //     console.log("close buton if");
            //     $("#add").modal("hide")
            //     $("#addActivity").modal("hide")
            // }
            if(this.$route.path==="/activities" || this.$route.path==="/deals" || this.$route.path==="/opportunities" || this.$route.path==="/notifications" || this.$route.path==="/reports" || this.$route.path==="/contactCard/" + this.$route.params.contactId || this.$route.path==="/organizationCard/" + this.$route.params.orgId || this.$route.path==="/dealCard/" + this.$route.params.dealId || this.$route.path==="/timeline"){
               
                var presentTime=this.$moment(new Date()).format("HH:mm")
                var changeTime=this.activityTime
                
                if(
                    this.activities['subject']==undefined && 
                    this.activitNote==undefined && 
                    presentTime===this.activityTime && 
                    this.activityPeriod=="00:00" && 
                    this.organizationKeyword=="" && 
                    this.contactKeyword=="" && 
                    this.dealKeyword=="" && 
                    this.assignedToValueTitle=="Seçiniz"
                ){

                    $("#add").modal("hide")
                    $("#addActivity").modal("hide")

                    if(this.data===undefined){
                        this.clear()
                        return
                    }

                    this.clearMethod2()
                    let statu=false
                    this.$store.dispatch('editLineStatu', statu)
                    return   
                }
            else{
                if(this.here){
                    $('#changeAlertModalActivity2').modal('show')
                    // this.customerFiles=[]
                }
                else{
                    $('[id=changeAlertModalActivity2]:eq(1)').modal('show')  
                    //  this.customerFiles=[]
                }
                // console.log("else girdi");
                // if($(".notificationDropDownModal")){
                //     $("#changeAlertmodalActivity2").modal("show")
                // }
                // $('#changeAlertModalActivity2').modal('show')
                // $('[id=changeAlertModalActivity2]:eq(1)').modal('show')     
                // $('#changeAlertModalActivity').css('display','block')   
                    // this.customerFiles=[]
                    // this.clearMethod2()
                    $(".crm-modal-body").css("display","none")
                    $(".crm-modal-header").css("position","absolute ")
                    $(".crm-modal-footer").css("display","none ")
                    $(".crm-modal-content").css("width","0 ")
                }
                
            }

             
        },
        closeButtonModal(){
            if(this.$route.path != "/reports"){
                $("#add").modal("hide")
                $("#addActivity").modal("hide")
                this.clearMethod2()
                document.querySelector(".modal-backdrop").style.display="none";
                $(".modal-backdrop").modal("hide")
                setTimeout(() => {
                    $(".crm-modal-body").css("display","block")
                    $(".crm-modal-header").css("position","sticky")
                    $(".crm-modal-footer").css("display","flex")
                    $(".crm-modal-content").css("width","100% ")
                }, 300);
            }  
            setTimeout(() => {
                $(".crm-modal-body").css("display","block")
                $(".crm-modal-header").css("position","sticky")
                $(".crm-modal-footer").css("display","flex")
                $(".crm-modal-content").css("width","100% ")
            }, 300); 
        },
        clearMethod2(){
            this.assignedToValueTitle=this.$ml.get('SELECT')
            this.assignedValueTitle=this.$ml.get('SELECT')
            this.activityId='',
            this.activities={},
            this.returnCustomField=[],
            this.activityTypeText="",
            this.activityDate=this.$moment(new Date()).format()
            this.activityTime=this.$moment(new Date()).format("HH:mm")
            this.activityPeriod="00:00"
            this.selectedDone="",
            this.isHiddenOrganization=false,
            this.isHiddenContact=false,
            this.isHiddenDeal=false,
            this.items=[],
            this.activities['note']="",
            this.activityTypes('call'),
            this.assignedToValue="0",
            this.assignedValue="0",
            this.createDate="",
            this.selected=undefined,
            this.notes=[],
            this.customFieldType=undefined
            if(this.$refs.addNotePanel!==undefined){
                this.$refs.addNotePanel.content=""
            }
            if(this.$route.path!="/dealCard/"+this.$route.params.dealId){
                this.dealKeyword=""
            }
            if(this.contactOrg===undefined && this.$route.path!="/dealCard/"+this.$route.params.dealId){
                this.contactKeyword=""
            }
            setTimeout(() => {
            this.clearCustomFields();
            }, 0);
            this.reminders=[
                {
                    day:'',
                    time:'12:00',
                    date:{$date:''},
                    isActive:true,
                    isQueued:false
                }
            ],
            setTimeout(() => {
                   $('#activity-tab').tab('show');
            }, 600);
         
        },
        clear(){
            this.assignedToValueTitle=this.$ml.get('SELECT')
            this.assignedValueTitle=this.$ml.get('SELECT')
            this.activities={},
            this.activityId="",
            this.returnCustomField=[],
            this.activityTypeText="",
            this.selectedDone="",
            this.organizationKeyword="",
            this.contactKeyword="",
            this.dealKeyword="",
            this.selectOrganization="",
            this.selectContact="",
            this.selectDeal="",
            this.isHiddenOrganization=false,
            this.isHiddenContact=false,
            this.isHiddenDeal=false,
            this.items=[],
            this.isNewOrganization=false
            this.organizationId="",
            this.contactId="",
            this.dealId="",
            this.activities['note']="",
            this.activityTypes('call'),
            this.assignedToValue="0",
            this.assignedValue="0",
            this.$store.state.editLine={},
            this.createDate="",
            this.selected=undefined,
            this.notes=[],
            this.customFieldType=undefined,
            this.activityDate=this.$moment(new Date()).format()
            this.activityTime=this.$moment(new Date()).format("HH:mm")
            this.activityPeriod="00:00"
            if(this.$refs.addNotePanel!==undefined){
            this.$refs.addNotePanel.content=""
            }
            setTimeout(() => {
            this.clearCustomFields();
            }, 0);
            this.reminders=[
                {
                    day:'',
                    time:'12:00',
                    date:{$date:''},
                    isActive:true,
                    isQueued:false
                }
            ],
            setTimeout(() => {
                 $('#activity-tab').tab('show');
            }, 600);
           
        },
        changeDate(){
            var day = new Date(this.activityDate).getDate()
            if(new Date(this.activityDate).getMonth()+1<10){
                var month = `0${new Date(this.activityDate).getMonth()+1}`
            }else{
                var month = new Date(this.activityDate).getMonth()+1
            }
            var year = new Date(this.activityDate).getFullYear()
            var date = year+"-"+month+"-"+day
            let datetime = this.$moment(date + " " + this.activityTime);
            this.activities["dueDate"] ={"$date": new Date(datetime.format())}
            if(this.activityPeriod!==undefined && this.activityPeriod!==""){
                this.activities["duration"]=this.activityPeriod
            }
            
        },
        combineDateAndTime(date, time) {
            var timeString = time.getHours() + ':' + time.getMinutes() + ':00';
            var ampm = time.getHours() >= 12 ? 'PM' : 'AM';
            var year = date.getFullYear();
            var month = date.getMonth() + 1; // Jan is 0, dec is 11
            var day = date.getDate();
            var dateString = '' + year + '-' + month + '-' + day;
            var datec = dateString + 'T' + timeString;
            var combined = new Date(datec);
            return combined;
        },
        routerRequest(field){
            if(field==="contact"){
                this.sipContactKeyword=false
                if(this.selectContact!==this.contactKeyword){
                    this.isHiddenContact=true
                    this.quickContact() 
                    this.isHiddenOrganization=false
                    this.isHiddenDeal=false 
                }
                if(this.contactKeyword===""){
                    this.quickContact() 
                }
            }
            if(field==="organization"){
                this.sipOrganizationKeyword=false
                if(this.selectOrganization!==this.organizationKeyword){
                    this.quickOrganization()
                    this.isHiddenContact=false
                    this.isHiddenDeal=false 
                }
                if(this.organizationKeyword===""){
                    this.quickOrganization() 
                }
            }
            if(field==="deal"){
                if(this.selectDeal!==this.dealKeyword){
                    this.quickDeal()
                    this.isHiddenOrganization=false
                    this.isHiddenContact=false 
                }
                if(this.dealKeyword===""){
                    this.quickDeal() 
                }
            }
        },
        setResult(result,type){
            if(type==="contact"){
                if(result.sn!==undefined){
                    this.contactKeyword=result.n+ " "+ result.sn
                    this.selectContact=result.n+ " "+ result.sn
                }else{
                    this.contactKeyword=result.n
                    this.selectContact=result.n
                }
                this.isHiddenContact= false
                this.contactId=result._id.$oid
                if(result.organizationName!==undefined){
                    this.organizationId=result.organization.$oid
                    this.organizationKeyword=result.organizationName
                    this.selectOrganization=result.organizationName
                }
            }
            if(type==="organization"){
                this.organizationKeyword=result.name
                this.isHiddenOrganization= false
                this.organizationId=result._id.$oid
                this.selectOrganization=result.name
            }
            if(type==="deal"){
                this.dealKeyword=result.title
                this.isHiddenDeal = false
                this.dealId=result._id.$oid
                this.selectDeal=result.title
            }
        },
        quickDeal(){
             
            axios({
                method:'POST',
                url:'/quickFilterDeal',
                baseURL: this.baseUrl,
                data: {
                    dealName:this.dealKeyword,
                    organizationId:this.organizationId,
                    contactId:this.contactId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.deals
                    //this.isHiddenDeal= true
                     
                }else{
                     
                }
            })
        },
        quickOrganization(){
             
            axios({
                method:'POST',
                url:'/quickFilterOrganization',
                baseURL: this.baseUrl,
                data: {
                    search:this.organizationKeyword,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.organizations
                    if(this.sipOrganizationKeyword==true){
                        this.isHiddenOrganization= false
                    }
                    else{
                        this.isHiddenOrganization= true
                    }
                    // this.isHiddenOrganization= true
                     
                }else{
                     
                }
            })
        },
        quickContact(){
            let obj = {}
            if(this.isNewOrganization){
                obj["search"]=this.contactKeyword
            }else{
                obj["search"]=this.contactKeyword
                obj["organizationId"]=this.organizationId
            }
            axios({
                method:'POST',
                url:'/quickFilterContact',
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.contacts
                    if(this.sipContactKeyword==true){
                        this.isHiddenContact= false
                    }
                    else{
                        if(this.contactKeyword!==''||this.organizationId!==''){
                            this.isHiddenContact= true
                        }
                    }
                    // if(this.contactKeyword!==''||this.organizationId!==''){
                    //     this.isHiddenContact= true
                    // }
                     
                }else{
                     
                }
            })
        },
        getUserFullName(userId){
            const user = (Array.isArray(this.users) ? this.users : []).find(usr => usr && usr._id && usr._id['$oid'] === userId)
            return user ? [user.name, user.surName].filter(Boolean).join(' ') : ''
        },
        getObjectId(value){
            if (!value) return ''
            if (typeof value === 'string') return value
            return value.$oid || (value._id && value._id.$oid) || ''
        },
        getFirstLinkedValue(value){
            return Array.isArray(value) ? value.find(Boolean) : value
        },
        dataFilling(updateData){
            if(!this.isEmpty(updateData)){
                if(updateData.edit){
                    if(updateData.subject!==undefined){
                        this.activities['subject']=updateData.subject
                    }
                    if(updateData.type!==undefined){
                        this.activities['type']=updateData.type
                        if(this.activities['type']===1){
                            this.activityTypes('call')
                        }else if(this.activities['type']===2){
                            this.activityTypes('meeting')
                        }else if(this.activities['type']===3){
                            this.activityTypes('task')
                        }else if(this.activities['type']===4){
                            this.activityTypes('email')
                        }
                    }
                    const assignedToId = this.getObjectId(updateData.assignedTo)
                    if(assignedToId){
                        this.assignedToValue=assignedToId
                        this.assignedToValueTitle=this.getUserFullName(assignedToId)
                    }
                    const assignorId = this.getObjectId(updateData.assignor)
                    if(assignorId){
                        this.assignedValue=assignorId
                        this.assignedValueTitle=this.getUserFullName(this.assignedValue)
                    }
                    const organization = this.getFirstLinkedValue(updateData.orgId)
                    const organizationId = this.getObjectId(organization)
                    if(organizationId){
                        if(this.$route.path==="/organizationCard/"+this.$route.params.orgId&&updateData.notificationModal!==true){
                            this.organizationId=organizationId
                        }else if(this.$route.path==="/contactCard/"+this.$route.params.contactId&&updateData.notificationModal!==true){
                            this.organizationId=organizationId
                            if(this.contactOrg){
                                this.setResult(this.contactOrg,'organization')
                            }
                        }else{
                            this.organizationKeyword=organization.name || ''
                            this.organizationId=organizationId
                            this.selectOrganization=organization.name || ''
                        }
                    }
                    const contact = this.getFirstLinkedValue(updateData.contactId)
                    const contactId = this.getObjectId(contact)
                    if(contactId){
                        const contactName = [contact.n, contact.sn].filter(Boolean).join(' ')
                        this.contactKeyword=contactName
                        this.isHiddenContact= false
                        this.contactId=contactId
                        this.selectContact=contactName
                    }
                    const deal = this.getFirstLinkedValue(updateData.dealId)
                    const dealId = this.getObjectId(deal)
                    if(dealId){
                        if(this.$route.path==="/dealCard/"+this.$route.params.dealId){
                            this.dealId=dealId
                        }else{
                            this.dealKeyword=deal.title || ''
                            this.isHiddenDeal = false
                            this.dealId=dealId
                            this.selectDeal=deal.title || ''
                        }
                        
                    }
                    if(updateData.notes!==undefined&&updateData.notes!==null){
                        if(typeof(updateData.notes)==="object"){
                            this.notes=updateData.notes
                            this.activitiesNote=""
                        }else{
                            this.activities['note']=""
                            this.activitiesNote=""
                        }
                        
                    }
                    if(updateData.duration!==undefined){
                        this.activityPeriod=updateData.duration
                    }
                    if(updateData.dueDate!==undefined){
                        this.activityDate=this.$moment(updateData.dueDate.$date).format()
                        this.activityTime=this.$moment(updateData.dueDate.$date).format("HH:mm")
                    }
                    if(updateData.addDate!==undefined){
                        this.createDate=this.$moment(updateData.addDate.$date).format()
                    }
                    const activityId = this.getObjectId(updateData._id)
                    if(activityId){
                        this.activityId=activityId
                    }
                    if(updateData.done!==undefined){
                        this.activities['done']=updateData.done
                    }
                }else{
                    if(updateData.subject!==undefined){
                        this.activities['subject']=updateData.subject.val
                    }
                    if(updateData.type!==undefined){
                        this.activities['type']=updateData.type.val
                        if(this.activities['type']===1){
                            this.activityTypes('call')
                        }else if(this.activities['type']===2){
                            this.activityTypes('meeting')
                        }else if(this.activities['type']===3){
                            this.activityTypes('task')
                        }else if(this.activities['type']===4){
                            this.activityTypes('email')
                        }
                        this.customFieldType=updateData.type.val
                        this.customFieldActive=true
                    }
                    if(updateData.assignedTo!==undefined){
                        this.assignedToValue=updateData.assignedTo.val.$oid
                        this.assignedToValueTitle=this.getUserFullName(updateData.assignedTo.val.$oid)
                    }
                    if(updateData.assignor!==undefined){
                        this.assignedValue=updateData.assignor.val.$oid
                        this.assignedValueTitle=this.getUserFullName(updateData.assignor.val.$oid)
                    }
                    if(updateData.orgId.val!==null && updateData.orgId.val[0]!==undefined){
                        this.organizationKeyword=updateData.orgId.val[0].name
                        this.isHiddenOrganization= false
                        this.organizationId=updateData.orgId.val[0]._id.$oid
                        this.selectOrganization=updateData.orgId.val[0].name
                    }
                 
                    if(updateData.contactId.val!==null && updateData.contactId.val[0]!==undefined){
                        if(updateData.contactId.val[0].sn !== undefined){
                            this.contactKeyword=updateData.contactId.val[0].n+" "+updateData.contactId.val[0].sn
                            this.selectContact=updateData.contactId.val[0].n+" "+updateData.contactId.val[0].sn
                        }
                        else{
                            this.contactKeyword=updateData.contactId.val[0].n
                            this.selectContact=updateData.contactId.val[0].n
                        }
                        this.isHiddenContact= false
                        this.contactId=updateData.contactId.val[0]._id.$oid
                       
                    }
                    
                   
                    if(updateData.dealId.val!==null && !this.isEmpty(updateData.dealId.val[0])){
                        this.dealKeyword=updateData.dealId.val[0].title
                        this.isHiddenDeal = false
                        this.dealId=updateData.dealId.val[0]._id.$oid
                        this.selectDeal=updateData.dealId.val[0].title
                    }
                    if(updateData.notes.val!==undefined&&updateData.notes.val!==null){
                        this.notes=updateData.notes.val
                        this.activitiesNote=""
                    }
                    if(updateData.duration!==undefined){
                        this.activityPeriod=updateData.duration.val
                    }
                    if(updateData.dueDate!==undefined){
                        this.activityDate=this.$moment(updateData.dueDate.val.$date).format()
                        this.activityTime=this.$moment(updateData.dueDate.val.$date).format("HH:mm")
                    }
                    if(updateData.addDate!==undefined){
                        this.createDate=this.$moment(updateData.addDate.val.$date).format()
                    }
                    if(updateData._id.val.$oid!==undefined){
                        this.activityId=updateData._id.val.$oid
                    }
                    if(updateData.done!==undefined){
                        this.activities['done']=updateData.done.val
                    }
                }
                this.getRemindersF()
            } 
        },
        isEmpty(obj) {
            if (obj == null) return true;
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;
            if (typeof obj !== "object") return true;
            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }
            return true;
        },
        ...mapActions([
            'updateLoading',
            'getReminders',
            'upsertReminder'
        ]),
    },
    mounted(){
        $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();
        
    },
    created(){
        this.clear()
        this.customFieldType=undefined
        this.assignedToValue="0"
        this.assignedValue="0"
        this.activityDate=this.$moment(new Date()).format()
        this.activityTime=this.$moment(new Date()).format("HH:mm")
        // this.activaTab()
        // this.$emit("activaTab",this.activaTab())
        this.$root.$refs.newActivities=this
    },
    watch: {
        '$route.params.page': 'path',
        organizationKeyword: _.debounce(function(addr) {
            this.addOrgArray['name']=this.organizationKeyword
            this.closeOrgButton()
            if(this.selectOrganization!==this.organizationKeyword && this.organizationKeyword.length!==0){
                this.quickOrganization()
                this.isHiddenContact=false
                this.isHiddenDeal=false 
            }
            if(this.organizationKeyword===""){
                this.isHiddenOrganization= false
                this.organizationId=""
                delete this.activities["orgId"]
            } 
        }, 300),
        contactKeyword: _.debounce(function() {
            this.addContactArray['name']=this.contactKeyword
            this.closeContactButton()
            if(this.contactKeyword===""){
                this.isHiddenContact= false
                delete this.activities["contactId"]
            } 
            if(this.selectContact!==this.contactKeyword && this.contactKeyword.length!==0){
                this.quickContact() 
                this.isHiddenOrganization=false
                this.isHiddenDeal=false 
            }
        }, 300),
        dealKeyword: _.debounce(function() {
            if(this.dealKeyword===""){
                this.dealId=""
                this.isHiddenDeal=false
                delete this.activities["dealId"]
            } 
            if(this.selectDeal!==this.dealKeyword && this.dealKeyword.length!==0){
                this.quickDeal()
                this.isHiddenOrganization=false
                this.isHiddenContact=false 
            }
        }, 300),
        
        listenState(data) {
            // `editLine` is shared by several list modals.  Ignore records from
            // other domains (for example products), which do not have the
            // activity-grid shape expected by dataFilling.
            const isActivityRecord = data && (
                Object.prototype.hasOwnProperty.call(data, 'subject') ||
                Object.prototype.hasOwnProperty.call(data, 'dueDate') ||
                Object.prototype.hasOwnProperty.call(data, 'assignedTo') ||
                Object.prototype.hasOwnProperty.call(data, 'assignor')
            )
            if (isActivityRecord) {
                this.dataFilling(data)
            }
        },
        listenStateStatus(data){
            if(data===false){
                this.$store.state.editLine=[]
                if(this.data===undefined){
                    this.clear()
                }else{
                    this.clearMethod2()
                }
            }
        },
        data:_.debounce(function(value) {

            if(value.name!==undefined){
                if(this.sipData == true){
                    this.sipOrganizationKeyword = true
                    this.sipContactKeyword = true
                    this.organizationKeyword = value.organization[0].name
                    if(value.sn !== undefined){
                        this.contactKeyword=value.n+ " "+ value.sn
                    }
                    else{
                        this.contactKeyword=value.n
                    }
                }
                else{
                    this.organizationKeyword=value.name
                    this.isHiddenOrganization= false
                    this.organizationId=value._id.$oid
                    this.selectOrganization=value.name
                    let obj ={}
                    obj["$oid"]=value._id.$oid
                    this.activities["orgId"]=obj
                    
                    this.dealKeyword=""
                    if(value.contacts!==undefined){
                        if(value.contacts.length===1){
                            this.isHiddenContact= false
                            this.contactId=value.contacts[0]._id.$oid
                            if(value.contacts[0].sn!==undefined){
                                this.contactKeyword=value.contacts[0].n+ " "+ value.contacts[0].sn
                                this.selectContact=value.contacts[0].n+ " "+ value.contacts[0].sn
                            }else{
                                this.contactKeyword=value.contacts[0].n
                                this.selectContact=value.contacts[0].n
                            }
                            let obj ={}
                            obj["$oid"]=value.contacts[0]._id.$oid
                            this.activities["contactId"]=obj
                            if(value.contacts[0].organization!==undefined){
                                this.organizationId=value.contacts[0].organization.$oid
                                this.organizationKeyword=value.name
                                this.selectOrganization=value.name
                            }
                        }
                        
                    }
                }
                
            }else if(value.title!==undefined){
                if(value.orgId!==undefined){
                    this.organizationKeyword=value.orgId.name
                    this.isHiddenOrganization= false
                    this.organizationId=value.orgId._id.$oid
                    this.selectOrganization=value.orgId.name
                    let obj ={}
                    obj["$oid"]=value.orgId._id.$oid
                    this.activities["orgId"]=obj
                }
                if(value!==undefined){
                    this.dealKeyword=value.title
                    this.isHiddenDeal = false
                    this.dealId=value._id.$oid
                    this.selectDeal=value.title
                    let obj ={}
                    obj["$oid"]=value._id.$oid
                    this.activities["dealId"]=obj
                }
                if(value.contactId!==undefined){
                    this.isHiddenContact= false
                    this.contactId=value.contactId._id.$oid
                    if(value.contactId.sn!==undefined){
                        this.contactKeyword=value.contactId.n+ " "+ value.contactId.sn
                        this.selectContact=value.contactId.n+ " "+ value.contactId.sn
                    }else{
                        this.contactKeyword=value.contactId.n
                        this.selectContact=value.contactId.n
                    }
                    let obj ={}
                    obj["$oid"]=value.contactId._id.$oid
                    this.activities["contactId"]=obj
                    if(value.contactId.organizationName!==undefined){
                        this.organizationId=value.contactId.organization.$oid
                        this.organizationKeyword=value.contactId.organizationName
                        this.selectOrganization=value.contactId.organizationName
                    }
                }
            }else{
                if(value!==undefined){
                    this.isHiddenContact= false
                    this.contactId=value._id.$oid
                    if(value.sn!==undefined){
                        this.contactKeyword=value.n+ " "+ value.sn
                        this.selectContact=value.n+ " "+ value.sn
                    }else{
                        this.contactKeyword=value.n
                        this.selectContact=value.n
                    }
                    let obj ={}
                    obj["$oid"]=value._id.$oid
                    this.activities["contactId"]=obj
                    this.dealKeyword=""
                }
            }
        }),
        contactOrg:_.debounce(function(value) {
            if(value!==undefined){
                this.organization=value
                this.organizationId=this.organization._id.$oid
                this.organizationKeyword=this.organization.name
                this.selectOrganization=this.organization.name
                
            }
            this.setResult(this.contact,'contact')
        }),
        clearModal:function(val){
            if(val){                
                if(this.data===undefined){
                    this.clear()
                }else{
                    this.clearMethod2()
                }
            }
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-header{
    background-color:#f3f6f9;
    position: sticky;
    top: 0;
    z-index: 1;
}
label{
    margin-bottom: 4px;
}
.modal-header li {
  font-size: 16px;
  margin-right: 5px;
}
.modal-header li a {
color: #93959A;
text-decoration: none;
height: 100%;
display: flex;
align-items: center;
padding: 0 13px;
}
.modal-header li a.active {
  color: #5b5f63;
  font-weight: bold;
  border-bottom: 3px solid #1991EB;
}
.iptal:before{
    color:red
}
.clickable{
    cursor: pointer;
}
.done:hover{
    background-color: #66D0FF30;
}
.done.active{
    background-color: #66D0FF30;
    border: 1px solid #66D0FF
}

@keyframes effect{
	0%{transform: scale(0);}
	25%{transform: scale(1.3);}
	75%{transform: scale(1.4);}
	100%{transform: scale(1);}
}
.previewNotes{
    max-height: 250px;
    overflow-y: auto;
}

</style>
